import React, { memo, useCallback, useState } from 'react';
import type { Editor } from 'slate';
import { useSlate } from 'slate-react';
import { ToolButton, ToolButtonIcon, ToolButtonWrapper } from './ToolBarStyles';
import ToolTip from './ToolTip';
import { ensureSelection, isMarkActive, toggleMark } from './utils';

interface MarkButtonProps {
  format: 'bold' | 'italic' | 'underline';
  icon: string;
}

export default memo(({ format, icon }: MarkButtonProps) => {
  const editor: Editor = useSlate();
  const [tooltipIsVisible, setTooltipIsVisible] = useState<boolean>(false);

  const handleToggleMark = useCallback(
    (event) => {
      event.preventDefault();
      ensureSelection(editor);
      toggleMark(editor, format);
    },
    [editor, format]
  );

  return (
    <ToolButtonWrapper>
      <ToolTip text={format} isVisible={tooltipIsVisible}>
        <ToolButton
          onClick={handleToggleMark}
          onMouseEnter={() => {
            setTooltipIsVisible(true);
          }}
          onMouseLeave={() => {
            setTooltipIsVisible(false);
          }}
        >
          <ToolButtonIcon $isActive={isMarkActive(editor, format)} src={icon} />
        </ToolButton>
      </ToolTip>
    </ToolButtonWrapper>
  );
});
